'use client';
import React, { ReactElement } from 'react';
// import { Heart, House, ShoppingCart } from 'lucide-react';
import Link from 'next/link';
// import useCart from '@/app/hooks/cart/useCart';
import ScrollToTopButton from '../ui/scrollUpButton';
import { useParams, usePathname } from 'next/navigation';
import HomeVector from '../ui/svg/navigation/home-icon';
import FavoritesVector from '../ui/svg/navigation/favorites-icon';
import CartVector from '../ui/svg/navigation/cart-icon';
import ProfileVector from '../ui/svg/navigation/profile-icon';
import CatalogVector from '../ui/svg/navigation/catalog-icon';
// import useFavorites from '@/app/hooks/favorites/useFavorites';

export default function Navigation(): ReactElement {
  // const { favorites } = useFavorites();
  // const { cartItems } = useCart();
  // const favoritesCount = favorites?.length;
  // const cartCount = cartItems?.length;
  const pathname = usePathname();
  const { section } = useParams<{ section?: string }>();
  const sectionValue = section?.toLowerCase();
  const sectionClasses = (() => {
    switch (sectionValue || pathname.split('/')[1]) {
      case 'woman':
        return 'bg-gradient-to-r from-[#810220] to-[#74011C] text-white';
      case 'man':
        return 'bg-gradient-to-t from-[#F3A61E] from-[0%] to-[#E89709] to-[93.75%] text-black';
      case 'home':
      case 'children':
      case 'cart':
      case 'favorites':
        return 'bg-gradient-to-t from-[#FFF] from-[21.59%] to-[#F7F7F7] to-[92.61%] text-black';
      default:
        return 'bg-gradient-to-r from-[#810220] to-[#74011C] text-white ';
    }
  })();
  const stroke =
    !sectionValue && (pathname === '/favorites' || pathname === '/cart')
      ? '#000'
      : sectionValue === 'woman' || !sectionValue
        ? '#fff'
        : '#000';
  return (
    <nav
      className={`fixed bottom-0 z-40 flex w-full justify-between ${sectionClasses} px-5 pb-4 pb-7 pt-3`}
    >
      <Link href="/">
        <div className="gap flex h-full flex-col items-center justify-between">
          <HomeVector width={20} height={20} strokeWidth="1" stroke={stroke} />
          <p className="text-[10px]">Главная</p>
        </div>
      </Link>
      <Link href="/catalog">
        <div className="gap flex h-full flex-col items-center justify-between">
          <CatalogVector width={20} height={20} stroke={stroke} />
          <p className="text-[10px]">Каталог</p>
        </div>
      </Link>
      <Link href="/favorites" className="relative">
        <div className="gap flex h-full flex-col items-center justify-between">
          <FavoritesVector
            width={24}
            height={24}
            className="stroke-[1.5px]"
            stroke={stroke}
          />
          {/* <p className="absolute bottom-4 right-2 flex h-2.5 w-2.5 items-center justify-center rounded-full border border-black px-1.5 py-1.5 text-[10px] leading-[normal]">
            {favoritesCount}
          </p> */}
          <p className="text-[10px]">Избранное</p>
        </div>
      </Link>
      <Link href="/cart" className="relative">
        <div className="gap flex h-full flex-col items-center justify-between">
          <CartVector
            width={20}
            height={20}
            className="stroke-[1.5px]"
            stroke={stroke}
          />

          {/* <p className="absolute bottom-4 right-[-3px] flex h-2.5 w-2.5 items-center justify-center rounded-full border border-black px-1.5 py-1.5 text-[10px] leading-[normal]">
            {cartCount}
          </p> */}
          <p className="text-[10px]">Корзина</p>
        </div>
      </Link>
      <Link href="/account">
        <div className="gap flex h-full flex-col items-center justify-between">
          <ProfileVector width={20} height={20} stroke={stroke} />
          <p className="text-[10px]">Профиль</p>
        </div>
      </Link>
      <ScrollToTopButton />
    </nav>
  );
}
